import { AppThunk } from 'app/store';

import { type CustomClientFormType, createCustomDeviceData } from '@ubnt/wifi-calculator/device/customClients';
import {
  devicesCustomClientFormEditDeviceSelector,
  devicesCustomClientFormOpenChange,
  devicesDeviceChange,
  devicesDeviceNameSelector,
  devicesUpdateCustomClientDevices,
} from './slice';
import { CLIENT_ID } from './constants';

export const devicesUpdateCustomClientDevice: (formData: Required<CustomClientFormType>) => AppThunk =
  (formData) => (dispatch, getState) => {
    const state = getState();
    const clientDeviceName = devicesDeviceNameSelector(state, CLIENT_ID);
    const editDeviceName = devicesCustomClientFormEditDeviceSelector(state);
    const changeToDevice = clientDeviceName !== editDeviceName;
    const deviceData = createCustomDeviceData(formData);
    const newCustomClientDevices: Record<string, LinkCore.DeviceData> = {};
    Object.values(deviceData).forEach((value) => {
      newCustomClientDevices[value.name] = value;
    });
    dispatch(
      devicesUpdateCustomClientDevices({
        deviceData: newCustomClientDevices,
        deviceName: formData.name,
      })
    );
    if (changeToDevice) {
      dispatch(devicesDeviceChange({ id: CLIENT_ID, name: formData.name }));
    }
    dispatch(devicesCustomClientFormOpenChange(false));
  };
